import { emptyObj } from 'util/objects'

export function selectRoomContactsBase(state) {
  const { chat: { contacts = emptyObj } = emptyObj } = state
  return contacts
}

export function selectContactByRoomId(state) {
  return selectRoomContactsBase(state).byRoomId || emptyObj
}
